import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-instagram-fill',
  shadow: false,
})
export class CmsIconInstagramFill {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 20 20"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 3.7V16.3C19 17.7912 17.7912 19 16.3 19H3.7C2.20883 19 1 17.7912 1 16.3V3.7C1 2.20883 2.20883 1 3.7 1H16.3C17.7912 1 19 2.20883 19 3.7ZM9.99999 5.00001C7.23857 5.00001 4.99999 7.23859 4.99999 10C4.99999 12.7614 7.23857 15 9.99999 15C12.7614 15 15 12.7614 15 10C15 7.23859 12.7614 5.00001 9.99999 5.00001ZM10 7C11.6569 7 13 8.34315 13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7ZM16 2.99999C15.4477 2.99999 15 3.4477 15 3.99999C15 4.55227 15.4477 4.99999 16 4.99999C16.5523 4.99999 17 4.55227 17 3.99999C17 3.4477 16.5523 2.99999 16 2.99999Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
